import styled from 'styled-components';

export const HeaderBelowStyled = styled.div`
  width: 100%;
  display: flex;
  border-bottom: 1px solid ${(props) => props?.theme?.color?.divider} !important;
  background: ${(props) => props?.theme?.color?.white};
  height: 40px;
  line-height: normal;
  position: absolute;
  top: 121px !important;
  z-index: 1099;
  &.fixed {
    top: ${(props) => (props.scrollY === 0 ? '121px !important' : '80px !important')};
    position: fixed;
  }
  margin-top: ${(props) => (props?.isNotSafari ? '53px' : '0px')};
  &.topZero {
    margin-top: ${(props) => (props?.isNotSafari ? '11px' : '0px')};
  }

  @media(max-width: 820px) {
    margin-top: ${(props) => (props?.isNotSafari ? '106px' : '4px')} !important;
    &.topZero {
      margin-top: ${(props) => (props?.isNotSafari ? '64px' : '4px')} !important;
    }
  }

  @media(max-width: 480px) {
    margin-top: ${(props) => (props?.isNotSafari ? '103px' : '4px')} !important;
    &.topZero {
      margin-top: ${(props) => (props?.isNotSafari ? '61px' : '4px')} !important;
    }
  }

  @media(max-width: 380px) {
    margin-top: ${(props) => (props?.isNotSafari ? '98px' : '4px')} !important;
    &.topZero {
      margin-top: ${(props) => (props?.isNotSafari ? '56px' : '4px')} !important;
    }
  }

  @media(max-width: 330px) {
    margin-top: ${(props) => (props?.isNotSafari ? '98px' : '4px')} !important;
    padding-bottom: 30px !important;
    &.topZero {
      margin-top: ${(props) => (props?.isNotSafari ? '56px' : '4px')} !important;
    }
  }

 .borderbrand{
  border-right:1px solid ${(props) => props.theme.color.divider};
  height:30px;
  @media(max-width: 1024px){
    position: relative;
    left: -7px;
  }
  @media (max-width: 1000px){
    border:none;
  }
 }

  .addressWrapper {
    padding: 8px 10px 8px 0px;
    @media (min-width: 1000px){
    width: max-content;
    }
  }
  .container {
    max-width: ${(props) => (props?.maxWidth ? '100%' : '1220px')};
    margin-left: 10px;
    @media (max-width: 1400px){
      margin-left:10px;
    }
  }
  .form-label {
    margin: 0 10px 0 0;
    color: ${(props) => props.theme.text.medium};
    display: flex;
  }

  @media(max-width:1024px){
    .addressWrapper{
        width:176px;
      }
  }
  @media (max-width: 1000px) {
    padding: 4px 0 40px;
    .category-wrapper {
      display: none;
    }
    .addressWrapper{
      width:400px;
    }
  }

  @media (max-width: 480px) {
    .category-wrapper {
      display: none;
    }

    .container {
      margin-left: 0;
      padding-top: 12px;
    }
    .addressWrapper {
      padding: 0;
      margin-right:10px;
    }
  }
  @media (max-width: 360px) {
    .category-wrapper {
      display: none;
    }

    .container {
      margin-left: 0;
      padding-top: 4px;
    }
    .addressWrapper {
      padding: 7px 0;
      margin-right:10px;
    }
  }
  
  .rtl {
    &.borderbrand {
      border: 0;
      border-left:1px solid ${(props) => props.theme.color.divider};
    }
    .addressWrapper {
      padding: 8px 0px 8px 10px;
      @media (max-width: 480px) {
        padding: 0;
      }
      @media (max-width: 360px) {
        padding: 7px 0;
      }
    }
  }
`;
